import { render } from "./AddButton.vue?vue&type=template&id=2ff440d2"
import script from "./AddButton.vue?vue&type=script&lang=js"
export * from "./AddButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__